import { defineStepper } from '@ui/stepper.tsx';
import { Cart } from '@client/components/cart/cart.tsx';
import { Shipping } from '@client/components/shipping/shipping.tsx';
import { useIsMobile } from '@r/hooks/use-mobile.ts';
import { OrderConfirmation } from '@client/components/order/order-confirmation.tsx';
import { OrderResult } from '@client/components/order/order-result.tsx';
import { Fragment } from 'react';
import Marquee from '@ui/marquee.tsx';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '@client/components/layout/page-container.tsx';

export const { StepperProvider, StepperNavigation, StepperStep, StepperTitle, useStepper } =
  defineStepper(
    {
      id: 'step-1',
      title: 'cart.details'
    },
    {
      id: 'step-2',
      title: 'shipping.address'
    },
    {
      id: 'step-3',
      title: 'order.confirmation'
    },
    {
      id: 'step-4',
      title: 'order.completed'
    }
  );

const Checkout = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <>
      <PageContainer className="flex pt-10 pb-7 grow">
        <StepperProvider
          className="flex flex-col space-y-10 grow"
          variant={isMobile ? 'vertical' : 'horizontal'}
        >
          {({ methods }) => (
            <Fragment>
              <StepperNavigation>
                {methods.all.map((step) => (
                  <StepperStep key={step.id} of={step.id}>
                    <StepperTitle>{t(step.title)}</StepperTitle>
                    {isMobile &&
                      methods.when(step.id, (step) => {
                        if (step.id === 'step-4') {
                          return <OrderResult />;
                        }

                        if (step.id === 'step-3') {
                          return <OrderConfirmation />;
                        }

                        if (step.id === 'step-2') {
                          return <Shipping />;
                        }

                        return <Cart />;
                      })}
                  </StepperStep>
                ))}
              </StepperNavigation>
              {!isMobile &&
                methods.switch({
                  'step-1': () => <Cart />,
                  'step-2': () => <Shipping />,
                  'step-3': () => <OrderConfirmation />,
                  'step-4': () => <OrderResult />
                })}
            </Fragment>
          )}
        </StepperProvider>
      </PageContainer>

      <Marquee text={t('shops.animated.text')} className="hidden lg:block" />
    </>
  );
};

export { Checkout };
